// extracted by mini-css-extract-plugin
export default {"statusSwitcher":"LineSwitch_statusSwitcher__c1+4J","statusOption":"LineSwitch_statusOption__WpeUD","selected":"LineSwitch_selected__e9JKF"};